"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _spinner = _interopRequireDefault(require("@atlaskit/spinner"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: spinnerStyles
  }, /*#__PURE__*/_react["default"].createElement(_spinner["default"], {
    interactionName: "load",
    size: "xlarge"
  }));
};
var _default = exports["default"] = LoadingSpinner;
var spinnerStyles = {
  position: 'fixed',
  left: '50%',
  top: '350px'
};